'use client';

import Link from 'next/link';
import BookDemoSection from '@/components/BookDemoSection';
import { Button } from '@/components/ui';
import { useTranslation } from "@/hooks/useTranslation";
const CATEGORIES = [{
  slug: 'industry-reports',
  label: 'Industry Reports',
  icon: '📊',
  tag: 'IN-DEPTH',
  desc: 'Data-driven research on CX trends, social benchmarks, and AI adoption across industries.',
  cta: 'Explore Reports →',
  img: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=80'
}, {
  slug: 'customer-stories',
  label: 'Customer Stories',
  icon: '⭐',
  tag: 'STORIES',
  desc: 'Real results from real brands — how 350+ enterprise teams transformed CX with Locobuzz.',
  cta: 'Read Stories →',
  img: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&q=80'
}, {
  slug: 'webinars',
  label: 'Webinars',
  icon: '🎥',
  tag: 'WEBINARS',
  desc: 'Live and on-demand expert sessions covering social intelligence, digital care, and unified CX strategy.',
  cta: 'Watch Webinars →',
  img: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=600&q=80'
}, {
  slug: 'podcasts',
  label: 'Podcasts',
  icon: '🎙️',
  tag: 'PODCASTS',
  desc: 'Deep conversations with CX leaders, marketing heads, and AI innovators shaping the future of CX.',
  cta: 'Listen Now →',
  img: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=600&q=80'
}, {
  slug: 'guides-and-ebooks',
  label: 'Guides & Ebooks',
  icon: '📚',
  tag: 'CONTENT',
  desc: 'Comprehensive playbooks on social media management, brand reputation, and unified CX workflows.',
  cta: 'Download Free →',
  img: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=600&q=80'
}, {
  slug: 'events',
  label: 'Events',
  icon: '📅',
  tag: 'ON & OFF SITE',
  desc: 'Conferences, roundtables, and Locobuzz-hosted events where CX leaders connect, learn, and grow.',
  cta: 'See Events →',
  img: 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=600&q=80'
}];
const STATS = [{
  n: '200+',
  label: 'Resources Published'
}, {
  n: '7',
  label: 'Content Categories'
}, {
  n: '50K+',
  label: 'Monthly Readers'
}, {
  n: 'Real-Time',
  label: 'AI at the Core™'
}];
const EDITORS_PICKS = [{
  type: 'INDUSTRY REPORT',
  title: 'The Rise of Quick Commerce in India',
  sub: 'Quick Commerce Consumer Intelligence Report | Trends & Insights',
  img: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=600&q=80',
  cta: 'Download Report →',
  url: '/resources/industry-reports/'
}, {
  type: 'PODCAST',
  title: 'VoCX — Future of Marketing: AI at the Core of Strategic Growth and Brand Integrity',
  sub: 'Episode 8 • 31 min',
  img: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=500&q=80',
  cta: 'Listen now →',
  url: '/resources/podcasts/'
}, {
  type: 'CUSTOMER STORY',
  title: 'How Hyundai Unified CX Across 900+ Locations with Locobuzz',
  sub: 'Case Study • 4 min read',
  img: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=500&q=80',
  cta: 'Read story →',
  url: '/resources/customer-stories/'
}, {
  type: 'FREE EBOOK',
  title: 'Bots, Brains, and Brand Loyalty: The Future of Customer Connection in 2026',
  sub: 'Free Ebook • 18 pages',
  img: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=500&q=80',
  cta: 'Download free →',
  url: '/resources/guides-and-ebooks/'
}];
export default function ResourcesPage() {
  const {
    t
  } = useTranslation();
  return <>
      {/* Hero */}
      <section style={{
      background: '#fff',
      position: 'relative',
      overflow: 'hidden',
      padding: 'var(--hero-pad)'
    }}>
        <div className="lb-hero-grad" style={{
        position: 'absolute',
        inset: 0
      }} />
        <div className="container" style={{
        position: 'relative',
        zIndex: 1,
        textAlign: 'center'
      }}>
          <span className="lb-pill" style={{
          marginBottom: 16
        }}>{t("resources.knowledge_hub")}</span>
          <h1 className="lb-h1" style={{
          maxWidth: 960,
          margin: '0 auto 20px'
        }}>
            {t("resources.everything_you_need_to")}{' '}
            <span style={{
            background: 'linear-gradient(135deg,#0077FF,#5232FF)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>{t("resources.master_modern_cx")}</span>
          </h1>
          <p style={{
          fontSize: 17,
          color: '#4B5563',
          maxWidth: 680,
          margin: '0 auto 36px',
          lineHeight: 1.7
        }}>
            {t("resources.from_industry_reports_to_webinars_p")}
          </p>
          <a href="#explore" className="lb-btn-primary">{t("resources.get_started")}</a>
        </div>
      </section>

      {/* Stats */}
      <section style={{
      background: '#F8FAFF',
      padding: '32px 0',
      borderTop: '1px solid #E5E7EB',
      borderBottom: '1px solid #E5E7EB'
    }}>
        <div className="container">
          <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 56,
          flexWrap: 'wrap'
        }}>
            {STATS.map(s => <div key={s.n} style={{
            textAlign: 'center'
          }}>
                <div style={{
              fontFamily: "'Inter',sans-serif",
              fontSize: 32,
              fontWeight: 900,
              color: '#0077FF',
              marginBottom: 4
            }}>{s.n}</div>
                <div style={{
              fontSize: 12,
              color: '#6B7280'
            }}>{s.label}</div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Explore by category */}
      <section className="lb-section" id="explore">
        <div className="container">
          <div style={{
          marginBottom: 40
        }}>
            <div style={{
            fontSize: 13,
            fontWeight: 700,
            color: '#6B7280',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            marginBottom: 8
          }}>{t("resources.explore_by_category")}</div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            gap: 12
          }}>
              <h2 className="lb-h2">{t("resources.every_format_one_platform")}</h2>
              <p style={{
              fontSize: 14,
              color: '#6B7280',
              maxWidth: 280
            }}>{t("resources.dive_into_any_topic_through_the_for")}</p>
            </div>
          </div>
          <div className="lb-grid-3">
            {CATEGORIES.map(cat => <Link key={cat.slug} href={'/resources/' + cat.slug} style={{
            textDecoration: 'none'
          }}>
                <div className="lb-card" style={{
              height: '100%',
              overflow: 'hidden',
              padding: 0
            }}>
                  <div style={{
                height: 160,
                overflow: 'hidden',
                position: 'relative'
              }}>
                    <img src={cat.img} alt={cat.label} loading="lazy" decoding="async" style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.4s'
                }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
                    <div style={{
                  position: 'absolute',
                  top: 12,
                  left: 12,
                  background: '#0077FF',
                  color: '#fff',
                  fontSize: 10,
                  fontWeight: 700,
                  padding: '3px 10px',
                  borderRadius: 100,
                  letterSpacing: '0.5px'
                }}>{cat.tag}</div>
                  </div>
                  <div style={{
                padding: 20
              }}>
                    <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  marginBottom: 10
                }}>
                      <span style={{
                    fontSize: 20
                  }}>{cat.icon}</span>
                      <span style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: '#111827'
                  }}>{cat.label}</span>
                    </div>
                    <p style={{
                  fontSize: 13,
                  color: '#6B7280',
                  lineHeight: 1.65,
                  marginBottom: 14
                }}>{cat.desc}</p>
                    <div style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: '#0077FF'
                }}>{cat.cta}</div>
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
      </section>

      {/* Editor's Picks */}
      <section className="lb-section-alt">
        <div className="container">
          <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 32,
          flexWrap: 'wrap',
          gap: 12
        }}>
            <div>
              <div style={{
              fontSize: 13,
              fontWeight: 700,
              color: '#6B7280',
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
              marginBottom: 6
            }}>{t("resources.featured_this_month")}</div>
              <h2 className="lb-h2">{t("resources.editors_picks")}</h2>
            </div>
            <div style={{
            fontSize: 13,
            color: '#6B7280'
          }}>{t("resources.handpicked_content_from_our_team_mo")}</div>
          </div>
          <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gap: 20,
          alignItems: 'start'
        }}>
            {/* Featured large */}
            <Link href={EDITORS_PICKS[0].url} style={{
            textDecoration: 'none'
          }}>
              <div className="lb-card" style={{
              padding: 0,
              overflow: 'hidden'
            }}>
                <div style={{
                height: 280,
                overflow: 'hidden',
                position: 'relative'
              }}>
                  <img src={EDITORS_PICKS[0].img} alt="" loading="lazy" decoding="async" style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }} />
                  <div style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to top,rgba(0,0,0,0.7) 0%,transparent 60%)'
                }} />
                  <div style={{
                  position: 'absolute',
                  bottom: 16,
                  left: 20,
                  right: 20
                }}>
                    <div style={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: '#64748B',
                    letterSpacing: '1px',
                    marginBottom: 6
                  }}>{EDITORS_PICKS[0].type}</div>
                    <div style={{
                    fontSize: 18,
                    fontWeight: 700,
                    color: '#fff',
                    lineHeight: 1.35
                  }}>{EDITORS_PICKS[0].title}</div>
                  </div>
                </div>
                <div style={{
                padding: 20
              }}>
                  <div style={{
                  fontSize: 13,
                  color: '#6B7280',
                  marginBottom: 14
                }}>{EDITORS_PICKS[0].sub}</div>
                  <div style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: '#0077FF'
                }}>{EDITORS_PICKS[0].cta}</div>
                </div>
              </div>
            </Link>
            {/* 3 smaller */}
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16
          }}>
              {EDITORS_PICKS.slice(1).map((pick, i) => <Link key={i} href={pick.url} style={{
              textDecoration: 'none'
            }}>
                  <div className="lb-card" style={{
                padding: 16,
                display: 'flex',
                gap: 14,
                alignItems: 'flex-start'
              }}>
                    <div style={{
                  width: 70,
                  height: 70,
                  borderRadius: 8,
                  overflow: 'hidden',
                  flexShrink: 0
                }}>
                      <img src={pick.img} alt="" loading="lazy" decoding="async" style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }} />
                    </div>
                    <div>
                      <div style={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: '#0077FF',
                    letterSpacing: '0.5px',
                    marginBottom: 4
                  }}>{pick.type}</div>
                      <div style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: '#111827',
                    lineHeight: 1.4,
                    marginBottom: 6
                  }}>{pick.title}</div>
                      <div style={{
                    fontSize: 11,
                    color: '#6B7280'
                  }}>{pick.sub}</div>
                    </div>
                  </div>
                </Link>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{
      background: 'linear-gradient(135deg,#EEF0FF 0%,#F0EEFF 40%,#EBF3FF 100%)',
      padding: 'var(--section-pad-tight)',
      textAlign: 'center'
    }}>
        <div className="container">
          <h2 style={{
          fontFamily: "'Inter',sans-serif",
          fontWeight: 900,
          fontSize: 'clamp(24px,3.5vw,44px)',
          color: '#0D1117',
          lineHeight: 1.15,
          marginBottom: 20
        }}>
            {t("resources.ready_to_unify_your_cx")}
          </h2>
          <p style={{
          fontSize: 16,
          color: '#64748B',
          marginBottom: 32,
          maxWidth: 480,
          margin: '0 auto 32px'
        }}>
            {t("resources.join_400_marketing_and_cx_teams_glo")}
          </p>
          <Button href="#book-demo" variant="cta" size="lg">{t("resources.try_locobuzz")}</Button>
        </div>
      </section>

      <BookDemoSection />
    </>;
}